import { z } from "zod";

export const platformDomainSlugSchema = z
  .string()
  .trim()
  .min(1)
  .regex(/^[a-z0-9-]+$/);

export const agelessMarketingQrFormSchema = z.object({
  assessmentUrl: z.string().url(),
});

export type AgelessMarketingQrFormValues = z.infer<typeof agelessMarketingQrFormSchema>;
